import { render, staticRenderFns } from "./VaultSetupAnotherDeviceGuide.vue?vue&type=template&id=5e0d606e&scoped=true"
import script from "./VaultSetupAnotherDeviceGuide.vue?vue&type=script&lang=js"
export * from "./VaultSetupAnotherDeviceGuide.vue?vue&type=script&lang=js"
import style0 from "./VaultSetup.scss?vue&type=style&index=0&id=5e0d606e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0d606e",
  null
  
)

export default component.exports